import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { useDispatch, useSelector } from "react-redux";
import { baseURL, logoutUser } from "../redux/Action";
import Details from "./Details";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BlogDetails = () => {
  const { user, isAuth, token } = useSelector((state) => state);
  const [blog, setBlog] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [show, setShow] = useState(false);
  const [likes, setLikes] = useState([]);
  const [comments, setComments] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = `Blogshog | Blog-${id}`;
    getBlog();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const notify = (msg) => toast(msg, { theme: "dark" });

  const getBlog = () => {
    setIsLoading(true);
    axios
      .get(`${baseURL}/blogs/${id}`, {
        withCredentials: true,
      })
      .then((res) => {
        const { blog, comments, likes } = res.data;
        setBlog([blog]);
        setComments(comments);
        setLikes(likes);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsError(true);
        setIsLoading(false);
      });
  };
  const getLikes = () => {
    axios
      .get(`${baseURL}/likes/${id}`)
      .then((res) => {
        setLikes(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsError(true);
        setIsLoading(false);
      });
  };

  const like = () => {
    if (!isAuth) {
      return navigate("/login");
    }
    const payload = {
      blog_id: id,
      emoji: "",
    };

    axios
      .post(`${baseURL}/likes/`, payload, {
        withCredentials: true,
        headers: {
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.message) {
          notify(res.data.message);
        } else {
          notify(res.data);
        }
        getLikes();
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          notify("Session Expired. Please Login Again");
          logoutUser(dispatch);
        }
      });
  };

  return (
    <div className="bg-[#f4f4f4] dark:bg-[#0a0a0a] min-h-screen text-black dark:text-white">
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            paddingTop: "20vh",
            height: "100vh",
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      ) : isError ? (
        <div className="pt-[100px] flex justify-center h-screen px-4">
          <div className="p-8 font-mono border border-red-500 text-red-500 bg-red-50 dark:bg-red-950 w-full max-w-2xl text-center h-fit shadow-[4px_4px_0px_0px_rgba(239,68,68,1)]">
            CRITICAL ERROR: ASSET NOT FOUND OR OFF-GRID.
          </div>
        </div>
      ) : (
        <>
          {blog.map((el, i) => {
            let published = new Date(el.createdAt.substring(0, 10));
            const updated = new Date(el.updatedAt);
            return (
              <Details
                key={i}
                published={published}
                like={like}
                comments={comments}
                setComments={setComments}
                el={el}
                updated={updated}
                id={id}
                likes={likes}
                setShow={setShow}
                show={show}
                user={user}
              />
            );
          })}
        </>
      )}
    </div>
  );
};

export default BlogDetails;
